import React from 'react';
import { Box, IconButton } from '@mui/material';
import { ActionsMenu } from 'components/shared/Menu/ActionsMenu';
import { Home, Restore, List, Remove, Add, Timeline } from '@mui/icons-material';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { DealActions } from './DealActions';
import { StagesList } from './StagesList';
import { StagesManagerViewProps } from './types';
import { StagesSkeleton } from './StagesSkeleton';
import { StagesTimeline } from '../stagesTimeline';
import { StyledContainer } from './StyledContainer';
import { StagesContainer } from './StagesContainer';

export const StagesWidget = (props: StagesManagerViewProps) => {
  const { isDealClosed, estimatedCloseDate, parentId, parentType, parentCreatedAt, closeInfo, onSwitchToLegacyStages } =
    props;

  return (
    <StagesContainer {...props}>
      {({
        stages,
        loading,
        actions,
        templates,
        stagesView,
        timelineView,
        activeTemplate,
        stagesViewType,
        activeDepartmentId,
        departmentsOptions,
        hasActiveStageUnfilledRequired,
      }) => (
        <StyledContainer>
          <RenderWithCondition
            condition={timelineView === 'off'}
            fallBack={
              <StagesTimeline
                parentId={parentId}
                parentType={parentType}
                parentCreatedAt={parentCreatedAt}
                activeTemplateId={activeTemplate}
                onBackToStages={actions.onSwitchTimeline}
              />
            }
          >
            <RenderWithFallback isLoading={loading.genericLoading} fallBack={<StagesSkeleton />}>
              <Box className="stagesWidgetHeader">
                <DealActions
                  voId={parentId}
                  loading={loading}
                  actions={actions}
                  closeInfo={closeInfo}
                  isDealClosed={isDealClosed}
                  activeStage={stages.activeStage}
                  estimatedCloseDate={estimatedCloseDate}
                  activeDepartmentId={activeDepartmentId}
                  departmentsOptions={departmentsOptions}
                  hasActiveStageUnfilledRequired={hasActiveStageUnfilledRequired}
                />

                <Box className="secondSection">
                  <IconButton
                    size="small"
                    color="primary"
                    className="icon-btn-bordered"
                    onClick={actions.onChangeViewType}
                  >
                    {stagesViewType === 'all' ? <Remove /> : <Add />}
                  </IconButton>

                  <StagesList
                    loading={loading}
                    onViewStage={actions.onViewStage}
                    viewedStage={stages.viewedStageId}
                    activeStage={stages.activeStageId!}
                    stages={templates[activeTemplate!]?.stages ?? []}
                  />

                  <Box className="stagesWidgetHeaderActions">
                    <RenderWithCondition condition={timelineView === 'off'}>
                      <IconButton
                        size="small"
                        color="primary"
                        className="icon-btn-bordered"
                        onClick={actions.onSwitchTimeline}
                      >
                        <Timeline />
                      </IconButton>
                    </RenderWithCondition>

                    <ActionsMenu
                      config={[
                        {
                          label: 'Legacy Stages',
                          action: onSwitchToLegacyStages,
                          icon: <Restore color="primary" />,
                        },
                        {
                          action: actions.onChangeViewType,
                          label: stagesViewType === 'active' ? 'View all stages ' : 'Default View',
                          icon: stagesViewType === 'active' ? <List color="primary" /> : <Home color="primary" />,
                        },
                      ]}
                    />
                  </Box>
                </Box>
              </Box>

              {stagesView}
            </RenderWithFallback>
          </RenderWithCondition>
        </StyledContainer>
      )}
    </StagesContainer>
  );
};
